import React from 'react';
import { useTranslation } from 'react-i18next';

import { LegacyFieldReadMode } from '~/legacy-components/LegacyForms';

import { EmpEmeContactType } from '../../data';

type Props = {
  data: EmpEmeContactType;
};

export const EmergencyContactReadMode = ({ data: emp }: Props) => {
  const { t } = useTranslation();

  return (
    <>
      <LegacyFieldReadMode label={t('fEmpEmeName')} value={emp?.fEmpEmeName} />
      <LegacyFieldReadMode
        label={t('fEmpEmePhone')}
        value={emp?.fEmpEmePhone}
      />
      <LegacyFieldReadMode
        label={t('fEmpEmeEmail')}
        value={emp?.fEmpEmeEmail}
      />
    </>
  );
};
